module.exports = __webpack_public_path__ + "static/media/dark-theme-stops.6d605262.svg";